import { FilterCriterionModel } from '@_types/types';
import { getModifiers } from '@helpers/functions';
import RequireJs from '@helpers/RequireJs';
import Icon from '@atoms/icons/Icon';

const FilterCriterion = (model: FilterCriterionModel) => {
  const styleModifier = getModifiers(model, 'kf-m-filter-criterion');
  const { options, searchId, excludeJs, checkIcon } = model;

  return (
    <div className={styleModifier} data-search-id={searchId}>
      {options?.map((option) => (
        <label key={option.value} className="kf-m-filter-criterion__option" htmlFor={`${searchId}-${option.value as string}`}>
          <input
            defaultChecked={option.selected}
            id={`${searchId}-${option.value as string}`}
            name={searchId}
            type="checkbox"
            value={option.value as string}
          />
          <span className="kf-m-filter-criterion__checkmark">{checkIcon && <Icon {...checkIcon} />}</span>
          {option.text}
        </label>
      ))}

      {!excludeJs && <RequireJs defer path={'filter-criterion'} />}
    </div>
  );
};

export default FilterCriterion;
